<!-- 在线课程 -->
<template>
    <div class="online-course">
        <div class="online-course-top">
            <div class="title">在线课程</div>
            <div class="more" @click="goMore">更多 ></div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="online-couse-list">
            <div class="onlin-couse-item" v-for="item in courseList" :key="item.id">
                <div class="course-background"></div>
                <count-up
                    class="infor-card-count user-created-count"
                    :id-name="`code_${item.name}`"
                    :end-val="item.number"
                    color="#27CDE6"
                    countSize="24px"
                    :countWeight="700"
                    :isConvert="1"
                    style="height:100%;"
                >
                </count-up>
                <div class="course-name">
                    {{ item.name }}
                </div>
            </div>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>
  
<script>
import { getOnlineCourseInfoAPI } from "@/service/api.js"
import CountUp from "@/components/countUp.vue";
  export default {
    name: 'online-course',
    components: {
        CountUp
    },
    props:{
        //请求参数
        params: {
            type: Object,
            default: ()=>{}
        },
    },
    data() {
        return {
            courseList:[]
        }
    },
    watch:{
        params: {
            deep: true,
            handler (val) {
                this.getOnlineCourseInfo();
            }
        }
    },
    methods: {
        /**
         * @name 跳转更多
         */
        goMore(){
            window.open(`https://jzjx.syjy.cn/teachermain/portal/teacher/teaDataCenter?token=${this.$store.getters.token}`,'_blank')
        },

        /**
         * @name 获取在线课程统计
         */
         getOnlineCourseInfo(){
            this.courseList = [];
            getOnlineCourseInfoAPI({...this.params}).then((res)=>{
                let courseList = [];
                courseList.push({
                    id:'1',
                    name:"专题课程数",
                    number:res.ztCsNum || 0
                })
                courseList.push({
                    id:'2',
                    name:"同步课程数",
                    number:res.tbCsNum || 0
                })
                courseList.push({
                    id:'3',
                    name:"累计学习人次",
                    number:res.stuNum || 0
                })
                this.courseList = courseList;
            }).catch((err)=>{
                this.$Message.error('在线课程数据统计获取失败！');
            })
         }
    },
    mounted(){
        this.getOnlineCourseInfo();
    },
  }
</script>
  
<style lang="scss" scoped>
.online-course{
    width: 100%;
    height: 175px;
    // padding: 0 15px;
    background: rgba(6,17,52,0.8);
    border: 1px solid #053882;
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    .online-course-top{
        position: relative;
        text-align: center;
        margin-bottom: 20px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 10px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .online-couse-list{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .onlin-couse-item{
            display: flex;
            flex-direction: column;
            width: 190px;
            height: 110px;
            position: relative;
            // background: url("../../../assets/images/sydataboard/bg2.png") no-repeat;
            // background-size: 100% 100%;
            .course-background{
                position: absolute;
                top:30px;
                bottom: 0;
                width: 100%;
                height: 70px;
                left: 0;
                background: url("../../../assets/images/sydataboard/bg2.png") no-repeat;
                background-size: 100% 100%;
            }
            .course-number{
                width: 100%;
                height: 80px;
                display: flex;
                justify-content: center;
                font-size: 24px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #27CDE6;
                // background: url("../../../assets/images/sydataboard/bg2.png") no-repeat;
                // background-size: 100% 100%;
            }
            .course-name{
                margin-top: 10px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
            }
        }
    }
    .top-left{
        position: absolute;
        top: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
}
</style>
<style lang="scss">
</style>